// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1SPT9","buttonText":"styles_buttonText__1twHO","buttonArrow":"styles_buttonArrow__2JmQs","subtitle":"styles_subtitle__2br_M"};